import '.d{display:flex;}.ssr-plugin'
import '.a6{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a5{align-items:center;}.ssr-plugin'
import '.a9{gap:0.5rem;}.ssr-plugin'
import '.ai{cursor:pointer;}.ssr-plugin'
import '.fx{padding:0.75rem;}.ssr-plugin'
import '.b7{border-radius:1.25rem;}.ssr-plugin'
import '.a0{border:var(--border-subtle);}.ssr-plugin'
import '.ad{background-color:var(--palette-white);}.ssr-plugin'
import '.fb{transition:background-color 0.2s ease;}.ssr-plugin'
import '.et{width:2.5rem;}.ssr-plugin'
import '.cu{height:2.5rem;}.ssr-plugin'
import '.i4{color:var(--palette-blue-700);}.ssr-plugin'
import '.i5{font-size:0.9rem;}.ssr-plugin'
import '.u{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="d a6 e a5 a9 ai fx b7 a0 ad fb"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="et cu d a5 a6 i4"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="i5 i4 u"
        >
          {label}
        </span>
      </styled.button>
    )
}